import React, { FC } from 'react';
import { GetAllCrewFiltered_getAllCrewFiltered as Crew } from '../../types/schemaTypes';
import { useLazyLoading } from '../_common';
import CrewItem from './CrewItem';
import './Crews.scss';

interface CrewListProps {
    crews: Crew[];
    refetch?: () => void;
    isLoading: boolean;
    canEditCrews: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
    onEditClick: (Crew: Crew) => void;
    onDelete?: (record: any) => void;
}

const CrewList: FC<CrewListProps> = ({
    crews,
    refetch,
    isLoading,
    isEndOfResults,
    onLoadMore,
    onEditClick,
    canEditCrews,
    onDelete,
}: CrewListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('crewList', isLoading, isEndOfResults, onLoadMore);

    if (refetch) {
        refetch();
    }

    return (
        <div className="Crews-List" onScroll={handleScroll}>
            {crews.map((crew, index) => (
                <CrewItem
                    key={crew.id ? crew.id.toString() : '0'}
                    index={index}
                    canEditCrews={canEditCrews}
                    crew={crew}
                    onEditClick={onEditClick}
                    onDelete={onDelete}
                ></CrewItem>
            ))}
        </div>
    );
};

export default CrewList;

